import { VERIFICATION_METHOD, VERIFICATION_RESULT } from '../../constants';
/**
 * Returns a verified authorization JWT for the given set of verifications.
 */
export function getAuthorization(verificationData = []) {
    var _a, _b;
    const data = (_b = (_a = verificationData
        .filter((v) => v.verificationResults === VERIFICATION_RESULT.VERIFIED)
        .filter((v) => {
        /**
         * Currently FIDO provides a non-MACS-compatible authorization, so omit it from the candidates.
         *
         * TODO: as part of the IAB effort, this will now be a MACS-compliant token, making this filter obsolete.
         * Remove this once this change is confirmed.
         * @see https://confluence.mastercard.int/x/PsHcUQ#id-[E71711][MLD][IAB][HERCULES]TAFMDESID&V(M2)-IPC
         */
        return v.verificationMethod !== VERIFICATION_METHOD.FIDO2;
    })) === null || _a === void 0 ? void 0 : _a.slice(-1).pop()) === null || _b === void 0 ? void 0 : _b.additionalData;
    return ensureBase64Decoded(data);
}
/**
 * Ensures that the given string is base64-decoded (if encoded as such).
 */
export function ensureBase64Decoded(data) {
    try {
        data = atob(data || '');
    }
    catch (error) { }
    return data || undefined;
}
